module.exports = __webpack_public_path__ + "img/payment-ovo.3faf2bf4.png";